// ************************************************************************************************************************************************************
//
// CONFIDENTIAL
// Unpublished Work, Copyright 2023, Baxter Healthcare Corporation. All rights reserved.
// For use only by Baxter Healthcare Corporation.
// This document contains proprietary information. It must not be reproduced
// or disclosed to others without prior written approval.
//
// Filename: Monitors.js
// Description: This file is responsible to show monitor Grid
//
// ************************************************************************************************************************************************************
import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  getMonitor,
  getMonitorsById,
  getUnassignedMoniters,
  getAssignedMoniters,
  searchMonitors,
  getDeletedMonitors,
  deleteMonitor,
  deleteSearchMonitor,
  deleteAssociateMonitor,
} from "./_redux/monitorCrud";
import AddMonitorPage from "./pages/AddMonitorPage";
import history from "../../history";
import * as Actions from "../redux/action";
import { withRouter } from "react-router";
import EditSvg from "../../../icons/EditSvg.svg";
import Refresh from "../../../icons/Refresh.svg";
import DownArrow from "../../../icons/DownArrow.svg";
import MonitorImg from "../../../icons/MonitorImg.svg";
import { Checkbox, Tooltip } from "@material-ui/core";
import { withStyles } from "@material-ui/core";
import Pagination from "@material-ui/lab/Pagination";
import { RecordsperPage } from "../../../Application_Constants";
import DeletePage from "./pages/DeletePage";
import {
  MenuType,
  DeletePopupMsg,
  SortOrder,
  MonitorColumns,
} from "../../../Application_Constants";
import { Divider } from "@material-ui/core";

class Monitors extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      monitors: [],
      error: false,
      loading: false,
      editId: null,
      modalShow: false,
      facilities: null,
      isEdit: false,
      search: "",
      timeZoneList: [],
      paginationLoading: false,
      totalCount: 0,
      currentPage: 1,
      sortedColumn: MonitorColumns.LAST_COMMUNICATION,
      checkedArray: [],
      skipedArray: [],
      isAllSelected: false,
      partiallySelected: false,
      deleteModalShow: false,
      deleteMsg: DeletePopupMsg.emptyMsg,
      toshowokbtn: true,
      deletePopupError: false,
      deleteLoader: false,
      sort_order: SortOrder.DESCENDING,
    };

    this.handleSort = this.handleSort.bind(this);
  }

  handlePageChange = (event, value) => {
    this.setState({
      ...this.state,
      currentPage: value,
    });
    setTimeout(() => {
      this.fetchMonitors();
    }, 0);
  };
  handleSort = (columnName) => {
    const { sortedColumn, sort_order } = this.state;
    const newSortBy =
      columnName === sortedColumn
        ? sort_order === SortOrder.ASCENDING
          ? SortOrder.DESCENDING
          : SortOrder.ASCENDING
        : SortOrder.ASCENDING;
    this.setState(
      {
        sort_order: newSortBy,
        sortedColumn: columnName,
        loading: false,
      },
      () => {
        this.fetchMonitors();
      }
    );
  };

  componentDidMount() {
    this.fetchMonitors();
    this.props.monitorDetails(false);
    this.props.MonitorListRefresh(false);  
    this.props.searchBarChange(true);
  }

  componentDidUpdate(prevProps, prevState) {
    setTimeout(() => {
      if (
        this.props.selectedMenu !== prevProps.selectedMenu ||
        this.props.searchMonitor !== prevProps.searchMonitor
      ) {
        this.setState({
          ...this.state,
          currentPage: 1,
          checkedArray: [],
          sort_order: SortOrder.DESCENDING,
          sortedColumn: MonitorColumns.LAST_COMMUNICATION,
          skipedArray: [],
          isAllSelected: false,
          partiallySelected: false,
        });
        this.fetchMonitors();
      }
      // To refresh the grid on add monitor popup close
      if (this.props.monitorListRefresh !== prevProps.monitorListRefresh && this.props.monitorListRefresh === true) {      
        this.props.MonitorListRefresh(false);        
        this.fetchMonitors();
      }
      if (
        this.props.isDelete !== prevProps.isDelete &&
        this.props.isDelete === true
      ) {
        this.props.handleDelete(false);
        setTimeout(() => {
          this.initializeDeletePopup();
          this.setState({
            ...this.state,
            deleteModalShow: true,
          });
        }, 0);
      }
    }, 0);
  }

  fetchMonitors() {
    this.setState({
      ...this.state,
      monitors: [],
    });
    setTimeout(() => {
      if (this.props.searchMonitor.length === 0) {
        switch (this.props.selectedMenu) {
          case MenuType.MONITOR_ALL:
            this.monitorsList();
            break;
          case MenuType.MONITOR_UNASSIGNED:
            this.unassignedMonitorsList();
            break;
          case MenuType.MONITOR_ASSIGNED:
            this.assignedMonitorsList();
            break;
          case MenuType.MONITOR_DELETED:
            this.deletedMonitorsList();
            break;
          case MenuType.FACILITY_ALL:
            if (
              this.props.changeFacilityName !== null &&
              this.props.changeFacilityMenu !== null &&
              this.props.changeFacilityMenu !== "" &&
              this.props.changeFacilityName !== ""
            )
              this.monitorByFacilityId();
            break;
          default:
            this.monitorsList();
        }
      } else {
        this.onSearchMonitors();
      }
    }, 0);
  }

  onSearchMonitors = () => {
    if (this.props.searchMonitor && this.props.searchMonitor.length !== 0) {
      if (this.state.currentPage !== 0) {
        this.setState({ ...this.state, loading: true, monitors: [] });
      } else {
        this.setState({
          ...this.state,
          paginationLoading: true,
        });
      }
      this.setState({ ...this.state, search: this.props.searchMonitor });
      const searchType =
        this.props.selectedMenu === MenuType.FACILITY_ALL &&
        this.props.selectedFacility !== undefined
          ? this.props.selectedFacility
          : this.props.selectedMenu;

      searchMonitors({
        searchValue: this.props.searchMonitor,
        facilityId: searchType,
        count: RecordsperPage,
        page: this.state.currentPage,
        sort_column: this.state.sortedColumn,
        sort_order: this.state.sort_order,
      })
        .then((response) => {
          const { data, status, message, count } = response.data;
          if (status) {
            this.setState(
              {
                ...this.state,
                monitors: data,
                loading: false,
                error: false,
                totalCount: count,
              },
              () => {
                this.pageChangeCBSelect();
              }
            );
          } else {
            this.setState({
              ...this.state,
              monitors: [],
              error: message,
              loading: false,
              paginationLoading: false,
              totalCount: 0,
            });
          }
        })
        .catch((error) => {
          this.setState({
            ...this.state,
            loading: false,
            error: error.message,
            paginationLoading: false,
            totalCount: 0,
          });
        });
    }
  };

  deletedMonitorApiCall(isForceDelete) {
    this.setState({ ...this.state, deleteLoader: true });
    if (
      this.props.searchMonitor &&
      this.props.searchMonitor.length !== 0 &&
      this.props.selectedMenu !== MenuType.FACILITY_ALL
    ) {
      deleteSearchMonitor(
        this.props.selectedMenu,
        isForceDelete,
        this.props.searchMonitor,
        this.state.checkedArray,
        this.state.skipedArray
      )
        .then((res) => {
          const { message } = res;
          if (res.status) {
            this.resetValues();
            this.fetchMonitors();
            this.props.refreshMonitorCount(true);
            this.setState({
              ...this.state,
              deleteLoader: false,
              deletePopupError: false,
              deleteModalShow: false,
            });
          } else {
            this.setState({
              ...this.state,
              deletePopupError: message,
              deleteLoader: false,
            });
          }
        })
        .catch((error) => {
          if (error.response) {
            if (
              error.response.status !== 404 &&
              error.response.status !== 802 &&
              error.response.status !== 803 &&
              error
            ) {
              this.setState({
                ...this.state,
                deleteLoader: false,
                deletePopupError: error.response.data.message,
              });
            }
            if (error.response.status === 802 && error) {
              this.setState({
                ...this.state,
                deleteLoader: false,
                deleteMsg: DeletePopupMsg.deleteRecord,
              });
            } else if (error.response.status === 803 && error) {
              this.setState({
                ...this.state,
                deleteLoader: false,
                deleteMsg: DeletePopupMsg.FacilityAssociations,
              });
            } else {
              this.props.history.push("error/error-v1");
            }
          } else {
            this.setState({
              ...this.state,
              deleteLoader: false,
              deletePopupError: error.message,
            });
          }
        });
    } else if (
      !this.props.searchMonitor &&
      this.props.searchMonitor.length === 0 &&
      this.props.selectedMenu === MenuType.FACILITY_ALL
    ) {
      deleteAssociateMonitor(
        this.props.selectedMenu,
        isForceDelete,
        this.props.selectedFacility,
        this.state.checkedArray,
        this.state.skipedArray
      )
        .then((res) => {
          const { message } = res;
          if (res.status) {
            this.resetValues();
            this.fetchMonitors();
            this.props.refreshMonitorCount(true);
            this.setState({
              ...this.state,
              deleteLoader: false,
              deletePopupError: false,
              deleteModalShow: false,
            });
          } else {
            this.setState({
              ...this.state,
              deletePopupError: message,
              deleteLoader: false,
            });
          }
        })
        .catch((error) => {
          if (error.response) {
            if (
              error.response.status !== 404 &&
              error.response.status !== 802 &&
              error.response.status !== 803 &&
              error
            ) {
              this.setState({
                ...this.state,
                deleteLoader: false,
                deletePopupError: error.response.data.message,
              });
            }
            if (error.response.status === 802 && error) {
              this.setState({
                ...this.state,
                deleteLoader: false,
                deleteMsg: DeletePopupMsg.deleteRecord,
              });
            } else if (error.response.status === 803 && error) {
              this.setState({
                ...this.state,
                deleteLoader: false,
                deleteMsg: DeletePopupMsg.FacilityAssociations,
              });
            } else {
              this.props.history.push("error/error-v1");
            }
          } else {
            this.setState({
              ...this.state,
              deleteLoader: false,
              deletePopupError: error.message,
            });
          }
        });
    } else if (
      this.props.searchMonitor &&
      this.props.searchMonitor.length !== 0 &&
      this.props.selectedMenu === MenuType.FACILITY_ALL
    ) {
      deleteAssociateMonitor(
        this.props.selectedMenu,
        isForceDelete,
        this.props.selectedFacility,
        this.state.checkedArray,
        this.state.skipedArray
      )
        .then((res) => {
          const { message } = res;
          if (res.status) {
            this.resetValues();
            this.fetchMonitors();
            this.props.refreshMonitorCount(true);
            this.setState({
              ...this.state,
              deleteLoader: false,
              deletePopupError: false,
              deleteModalShow: false,
            });
          } else {
            this.setState({
              ...this.state,
              deletePopupError: message,
              deleteLoader: false,
            });
          }
        })
        .catch((error) => {
          if (error.response) {
            if (
              error.response.status !== 404 &&
              error.response.status !== 802 &&
              error.response.status !== 803 &&
              error
            ) {
              this.setState({
                ...this.state,
                deleteLoader: false,
                deletePopupError: error.response.data.message,
              });
            }
            if (error.response.status === 802 && error) {
              this.setState({
                ...this.state,
                deleteLoader: false,
                deleteMsg: DeletePopupMsg.deleteRecord,
              });
            } else if (error.response.status === 803 && error) {
              this.setState({
                ...this.state,
                deleteLoader: false,
                deleteMsg: DeletePopupMsg.FacilityAssociations,
              });
            } else {
              this.props.history.push("error/error-v1");
            }
          } else {
            this.setState({
              ...this.state,
              deleteLoader: false,
              deletePopupError: error.message,
            });
          }
        });
    } else {
      deleteMonitor(
        this.props.selectedMenu,
        isForceDelete,
        this.state.checkedArray,
        this.state.skipedArray
      )
        .then((res) => {
          const { message } = res;
          if (res.status) {
            this.resetValues();
            this.fetchMonitors();
            this.props.refreshMonitorCount(true);
            this.setState({
              ...this.state,
              deleteLoader: false,
              deletePopupError: false,
              deleteModalShow: false,
            });
          } else {
            this.setState({
              ...this.state,
              deletePopupError: message,
              deleteLoader: false,
            });
          }
        })
        .catch((error) => {
          if (error.response) {
            if (
              error.response.status !== 404 &&
              error.response.status !== 802 &&
              error.response.status !== 803 &&
              error
            ) {
              this.setState({
                ...this.state,
                deleteLoader: false,
                deletePopupError: error.response.data.message,
              });
            }
            if (error.response.status === 802 && error) {
              this.setState({
                ...this.state,
                deleteLoader: false,
                deleteMsg: DeletePopupMsg.deleteRecord,
              });
            } else if (error.response.status === 803 && error) {
              this.setState({
                ...this.state,
                deleteLoader: false,
                deleteMsg: DeletePopupMsg.FacilityAssociations,
              });
            } else {
              this.props.history.push("error/error-v1");
            }
          } else {
            this.setState({
              ...this.state,
              deleteLoader: false,
              deletePopupError: error.message,
            });
          }
        });
    }
  }

  resetValues() {
    this.setState({
      ...this.state,
      checkedArray: [],
      skipedArray: [],
      isAllSelected: false,
      partiallySelected: false,
      deleteMsg: DeletePopupMsg.emptyMsg,
      toshowokbtn: true,
      currentPage: 1,
    });
  }

  unassignedMonitorsList = () => {
    if (this.state.currentPage !== 0) {
      this.setState({ ...this.state, loading: true, monitors: [] });
    }

    getUnassignedMoniters(
      RecordsperPage,
      this.state.currentPage,
      this.state.sortedColumn,
      this.state.sort_order
    )
      .then((res) => {
        const { data, status, message, count } = res.data;
        if (status) {
          this.setState(
            {
              ...this.state,
              monitors: data,
              loading: false,
              error: false,
              totalCount: count,
            },
            () => {
              this.pageChangeCBSelect();
            }
          );
        } else {
          this.setState({
            ...this.state,
            error: message,
            loading: false,
            paginationLoading: false,
            totalCount: 0,
          });
        }
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status !== 404 && error) {
            this.setState({
              ...this.state,
              monitors: [],
              loading: false,
              error: error.response.data.message,
              paginationLoading: false,
              totalCount: 0,
            });
          } else {
            this.props.history.push("error/error-v1");
          }
        } else {
          this.setState({
            ...this.state,
            monitors: [],
            loading: false,
            error: error.message,
            paginationLoading: false,
            totalCount: 0,
          });
        }
      });
  };
  assignedMonitorsList = () => {
    if (this.state.currentPage !== 0) {
      this.setState({
        ...this.state,
        loading: true,
        monitors: [],
      });
    }
    getAssignedMoniters(
      RecordsperPage,
      this.state.currentPage,
      this.state.sortedColumn,
      this.state.sort_order
    )
      .then((res) => {
        const { data, status, message, count } = res.data;
        if (status) {
          this.setState(
            {
              ...this.state,
              monitors: data,
              loading: false,
              error: false,
              totalCount: count,
            },
            () => {
              this.pageChangeCBSelect();
            }
          );
        } else {
          this.setState({
            ...this.state,
            error: message,
            loading: false,
            paginationLoading: false,
            totalCount: 0,
          });
        }
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status !== 404 && error) {
            this.setState({
              ...this.state,
              monitors: [],
              loading: false,
              error: error.response.data.message,
              paginationLoading: false,
              totalCount: 0,
            });
          } else {
            this.props.history.push("error/error-v1");
          }
        } else {
          this.setState({
            ...this.state,
            monitors: [],
            loading: false,
            error: error.message,
            paginationLoading: false,
            totalCount: 0,
          });
        }
      });
  };

  deletedMonitorsList = () => {
    if (this.state.currentPage !== 0) {
      this.setState({ ...this.state, loading: true, monitors: [] });
    }
    getDeletedMonitors(
      RecordsperPage,
      this.state.currentPage,
      this.state.sortedColumn,
      this.state.sort_order
    )
      .then((res) => {
        const { data, status, message, count } = res.data;
        if (status) {
          this.setState({
            ...this.state,
            monitors: data,
            loading: false,
            error: false,
            totalCount: count,
          });
        } else {
          this.setState({
            ...this.state,
            error: message,
            loading: false,
            paginationLoading: false,
            totalCount: 0,
          });
        }
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status !== 404 && error) {
            this.setState({
              ...this.state,
              monitors: [],
              loading: false,
              error: error.response.data.message,
              paginationLoading: false,
            });
          } else {
            this.props.history.push("error/error-v1");
          }
        } else {
          this.setState({
            ...this.state,
            monitors: [],
            loading: false,
            error: error.message,
            paginationLoading: false,
            totalCount: 0,
          });
        }
      });
  };

  monitorsList = () => {
    if (this.state.currentPage !== 0) {
      this.setState({ ...this.state, loading: true, monitors: [] });
    }
    getMonitor(
      RecordsperPage,
      this.state.currentPage,
      this.state.sortedColumn,
      this.state.sort_order
    )
      .then((res) => {
        const { data, status, message, count } = res.data;
        if (status) {
          this.setState(
            {
              ...this.state,
              monitors: data,
              loading: false,
              error: false,
              totalCount: count,
            },
            () => {
              this.pageChangeCBSelect();
            }
          );
        } else {
          this.setState({
            ...this.state,
            error: message,
            loading: false,
            paginationLoading: false,
            totalCount: 0,
          });
        }
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status !== 404 && error) {
            this.setState({
              ...this.state,
              monitors: [],
              loading: false,
              error: error.response.data.message,
              paginationLoading: false,
              totalCount: 0,
            });
          } else {
            this.props.history.push("error/error-v1");
          }
        } else {
          this.setState({
            ...this.state,
            monitors: [],
            loading: false,
            error: error.message,
            paginationLoading: false,
            totalCount: 0,
          });
        }
      });
  };
  monitorByFacilityId = () => {
    if (this.state.currentPage !== 0) {
      this.setState({ ...this.state, loading: true, monitors: [] });
    }
    getMonitorsById(
      this.props.selectedFacility,
      RecordsperPage,
      this.state.currentPage,
      this.state.sortedColumn,
      this.state.sort_order
    )
      .then((res) => {
        const { data, status, message, count } = res.data;
        if (status) {
          this.setState(
            {
              ...this.state,
              monitors: data,
              loading: false,
              error: false,
              totalCount: count,
            },
            () => {
              this.pageChangeCBSelect();
            }
          );
        } else {
          this.setState({
            ...this.state,
            error: message,
            loading: false,
            paginationLoading: false,
            totalCount: 0,
          });
        }
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status !== 404 && error) {
            this.setState({
              ...this.state,
              monitors: [],
              loading: false,
              error: error.response.data.message,
              paginationLoading: false,
            });
          } else {
            this.props.history.push("error/error-v1");
          }
        } else {
          this.setState({
            ...this.state,
            monitors: [],
            loading: false,
            error: error.message,
            paginationLoading: false,
            totalCount: 0,
          });
        }
      });
  };

  editMonitor = (id) => {
    this.setState({
      ...this.state,
      editId: id,
      modalShow: true,
      isEdit: true,
    });
  };

  refreshMonitorGrid = () => {
    if (this.props.searchMonitor.length !== 0) {
      this.onSearchMonitors();
      this.setState({
        ...this.state,
        loading: true,
      });
    } else {
      this.fetchMonitors();
      this.props.refreshMonitorCount(true);
    }
  };
  modalClose = (opt) => {
    this.setState({
      ...this.state,
      modalShow: false,
      isEdit: false,
    });
    if (opt === "add") {
      this.fetchMonitors();
      this.props.refreshMonitorCount(true);
      this.props.refreshAssociateApi(true);
    }
  };

  toggleShown(value) {
    this.props.monitorDetails(true);
    this.props.searchBarChange(false);
    this.props.facilityDetailsChange(false);
    history.push("/dashboard/monitor-details/" + value.id);
  }

  selectAll() {
    const hasToCheckAll = !this.state.isAllSelected;
    this.state.monitors.map((item) => {
      item.checked = hasToCheckAll;
      return item;
    });
    this.setState({
      ...this.state,
      partiallySelected: false,
      isAllSelected: !this.state.isAllSelected,
      checkedArray: [],
      skipedArray: [],
    });
  }

  handleSingleSelect = (clickedItem) => {
    clickedItem.checked = !clickedItem.checked;
    if (this.state.isAllSelected) {
      if (clickedItem.checked === true) {
        const skipedArrayindex = this.state.skipedArray.indexOf(clickedItem.id);
        if (skipedArrayindex > -1) {
          this.state.skipedArray.splice(skipedArrayindex, 1);
        }
      } else {
        this.state.skipedArray.push(clickedItem.id);
      }
    } else {
      if (clickedItem.checked === true) {
        this.setState({
          ...this.state,
          partiallySelected: true,
        });
        this.state.checkedArray.push(clickedItem.id);
      } else {
        const checkedArrayindex = this.state.checkedArray.indexOf(
          clickedItem.id
        );
        if (checkedArrayindex > -1) {
          this.state.checkedArray.splice(checkedArrayindex, 1);
        }
      }
    }

    this.toCheckAllBox();
  };

  toCheckAllBox() {
    if (this.state.totalCount === this.state.checkedArray.length.toString()) {
      this.setState({
        ...this.state,
        partiallySelected: false,
        isAllSelected: true,
        checkedArray: [],
        skipedArray: [],
      });
    } else if (
      this.state.totalCount === this.state.skipedArray.length.toString()
    ) {
      this.setState({
        ...this.state,
        partiallySelected: false,
        isAllSelected: false,
        checkedArray: [],
        skipedArray: [],
      });
    } else if (
      this.state.skipedArray.length === 0 &&
      this.state.checkedArray.length === 0
    ) {
      this.setState({
        ...this.state,
        partiallySelected: false,
        isAllSelected: this.state.isAllSelected,
      });
    } else {
      this.setState({
        ...this.state,
        partiallySelected: true,
      });
    }
  }

  pageChangeCBSelect() {
    const tempDate = this.state.monitors;
    if (this.state.isAllSelected) {
      tempDate.forEach((item) => {
        if (this.state.skipedArray.includes(item.id)) {
          item.checked = false;
        } else {
          item.checked = this.state.isAllSelected;
        }
      });
    } else {
      tempDate.forEach((item) => {
        if (this.state.checkedArray.includes(item.id)) {
          item.checked = true;
        }
      });
    }
    this.setState({
      ...this.state,
      monitors: tempDate,
    });
  }

  deletemodalClose = (opt) => {
    if (opt === "cancel" || opt === "ok") {
      this.setState({
        ...this.state,
        deleteModalShow: false,
        deletePopupError: "",
      });
    } else if (opt === "continue") {
      this.deletedMonitorApiCall(true);
    }
  };

  initializeDeletePopup() {
    if (this.state.isAllSelected || this.state.checkedArray.length > 0) {
      this.deletedMonitorApiCall(false);
      this.setState({
        ...this.state,
        toshowokbtn: false,
      });
    } else {
      this.setState({
        ...this.state,
        deleteMsg: DeletePopupMsg.emptyMsg,
        toshowokbtn: true,
      });
    }
  }

  render() {
    const {
      monitors,
      loading,
      error,
      currentPage,
      sortedColumn,
      sort_order,
      totalCount,
      deleteModalShow,
      deleteMsg,
      toshowokbtn,
      deletePopupError,
      deleteLoader,
      paginationLoading,
      facilities,
      isEdit,
      editId,
      modalShow,
      isAllSelected,
      partiallySelected,
    } = this.state;
    const totalPages = Math.ceil(totalCount / RecordsperPage);
    const options = { hour12: false };

    const LightTooltip = withStyles((theme) => ({
      tooltip: {
        boxShadow: theme.shadows[1],
        fontSize: 11,
        padding: "8px",
        fontFamily: "Noto Sans Display",
      },
    }))(Tooltip);

    return (
      <>
        <button
          className="button-refresh-monitorGrid"
          onClick={this.refreshMonitorGrid}
        >
          <img className="imgCloud" src={Refresh} alt="Refresh"></img>
          <span className="imgCloudSpan">Refresh</span>
        </button>
        <h1 className="text-Heading">
          <img src={MonitorImg} alt="MonitorImg"></img>
          {this.props.selectedMenu === MenuType.MONITOR_UNASSIGNED ? (
            <span>Unassigned Monitors</span>
          ) : this.props.selectedMenu === MenuType.MONITOR_ASSIGNED ? (
            <span>Assigned Monitors</span>
          ) : this.props.selectedMenu === MenuType.MONITOR_DELETED ? (
            <span>Deleted Monitors</span>
          ) : (
            <span>All Monitors</span>
          )}
        </h1>
        <Divider></Divider>
        <div>
          <div className="row" style={{ margin: "0" }}>
            <div
              className="table-responsive tableFixHead font_family"
              id="monitorScroll"
              onScroll={paginationLoading ? this.pagination : null}
              style={{ height: "70vh" }}
            >
              <table
                className="table table-hover table-striped table-hover align-middle"
                style={{ marginBottom: "0", padding: "0" }}
              >
                <thead>
                  <tr>
                    <th
                      style={{ width: "10px" }}
                      className={
                        this.props.selectedMenu === MenuType.MONITOR_DELETED
                          ? "hidden_delete"
                          : null
                      }
                    >
                      <Checkbox
                        style={{ marginLeft: "2.5rem", color: "lightgray" }}
                        disabled={totalCount === 0}
                        checked={isAllSelected}
                        indeterminate={partiallySelected}
                        onChange={(e) => this.selectAll()}
                      ></Checkbox>
                    </th>

                    <th
                      style={{
                        paddingLeft: "68px",
                        fontWeight: 500,
                        fontSize: "16px",
                        color: "#145898",
                        width: "219px",
                        cursor: "pointer",
                      }}
                      onClick={() => this.handleSort(MonitorColumns.STATUS)}
                    >
                      Status{" "}
                      {sortedColumn === MonitorColumns.STATUS &&
                        (sort_order === SortOrder.ASCENDING ? (
                          <img
                            className="imgdesc"
                            style={{ paddingRight: "60px" }}
                            src={DownArrow}
                            alt="DownArrow"
                          ></img>
                        ) : (
                          <img
                            className="imgasc"
                            style={{ paddingLeft: "60px" }}
                            src={DownArrow}
                            alt="DownArrow"
                          ></img>
                        ))}
                    </th>
                    <th
                      style={{
                        paddingLeft: "40px",
                        marginTop: "20px",
                        marginBottom: "20px",
                        width: "350px",
                        cursor: "pointer",
                      }}
                      onClick={() => this.handleSort(MonitorColumns.MONITOR_ID)}
                    >
                      Monitor Name{" "}
                      {sortedColumn === MonitorColumns.MONITOR_ID &&
                        (sort_order === SortOrder.ASCENDING ? (
                          <img className="imgdesc" src={DownArrow}  alt="DownArrow"></img>
                        ) : (
                          <img className="imgasc" src={DownArrow}  alt="DownArrow"></img>
                        ))}
                    </th>

                    <th
                      style={{
                        paddingLeft: "18px",
                        marginTop: "20px",
                        marginBottom: "20px",
                        width: "400px",
                        cursor: "pointer",
                      }}
                      onClick={() =>
                        this.handleSort(MonitorColumns.MONITOR_SRNO)
                      }
                    >
                      Monitor Serial Number{" "}
                      {sortedColumn === MonitorColumns.MONITOR_SRNO &&
                        (sort_order === SortOrder.ASCENDING ? (
                          <img
                            className="imgdesc"
                            style={{ paddingRight: "30px" }}
                            src={DownArrow}
                            alt="DownArrow"
                          ></img>
                        ) : (
                          <img
                            className="imgasc"
                            style={{ paddingLeft: "30px" }}
                            src={DownArrow}
                            alt="DownArrow"
                          ></img>
                        ))}
                    </th>
                    <th
                      style={{
                        paddingLeft: "23px",
                        marginTop: "20px",
                        marginBottom: "20px",
                        width: "400px",
                        cursor: "pointer",
                      }}
                      onClick={() =>
                        this.handleSort(MonitorColumns.LAST_COMMUNICATION)
                      }
                    >
                      Cloud Comm.{" "}
                      {sortedColumn === MonitorColumns.LAST_COMMUNICATION &&
                        (sort_order === SortOrder.ASCENDING ? (
                          <img
                            className="imgdesc"
                            style={{ paddingRight: "20px" }}
                            src={DownArrow}
                            alt="DownArrow"
                          ></img>
                        ) : (
                          <img
                            className="imgasc"
                            style={{ paddingLeft: "20px" }}
                            src={DownArrow}
                            alt="DownArrow"
                          ></img>
                        ))}
                    </th>
                    <th>
                      <div style={{ textAlign: "right", marginRight: "45px" }}>
                        Edit
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody className="table-group-divider">
                  {loading ? (
                    <tr>
                      <td colSpan="12" align="center">
                        <div class="d-flex justify-content-center">
                          {" "}
                          <span
                            style={{ justifyContent: "center" }}
                            className="ml-3 spinner spinner-dark "
                          ></span>
                        </div>
                      </td>
                    </tr>
                  ) : (
                    monitors &&
                    monitors.map((value, index) => (
                      <tr key={index} className="cursor_pointer">
                        <td
                          style={{ width: "5px" }}
                          className={
                            this.props.selectedMenu === MenuType.MONITOR_DELETED
                              ? "hidden_delete"
                              : null
                          }
                        >
                          <Checkbox
                            style={{ marginLeft: "2.5rem", color: "lightgray" }}
                            checked={value.checked}
                            onChange={(e) => this.handleSingleSelect(value)}
                          ></Checkbox>
                        </td>
                        <td
                          data-label="Status"
                          onClick={() => this.toggleShown(value)}
                          style={{ width: "181px" }}
                        >
                          <div style={{ display: "flex" }}>
                            <img
                              src={MonitorImg}
                              alt="MonitorImg"
                              style={{
                                marginTop: "15px",
                                marginBottom: "12px",
                                marginRight: "26px",
                              }}
                            ></img>

                            <div
                              className={
                                value.online_status !== false
                                  ? "online"
                                  : "monitor-status"
                              }
                            >
                              <p
                                style={{
                                  margin: 8,
                                  fontFamily: "Noto Sans Display",
                                  fontWeight: "500",
                                  fontSize: "16px",
                                  textAlign: "center",
                                  textTransform: "capitalize",
                                }}
                              >
                                {value.online_status !== false ? (
                                  <span> Online </span>
                                ) : (
                                  <span>Offline</span>
                                )}
                              </p>
                            </div>
                          </div>
                        </td>

                        <LightTooltip
                          PopperProps={{ style: { marginTop: "-25px" } }}
                          disableHoverListener={!value.monitor_id}
                          title=<span style={{ fontSize: "12px" }}>
                            {value.monitor_id}{" "}
                          </span>
                        >
                          <td
                            data-label="Monitor ID"
                            onClick={() => this.toggleShown(value)}
                            className="text-containt"
                            style={{
                              width: "350px",
                              paddingLeft: "40px",

                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {value.monitor_id}
                          </td>
                        </LightTooltip>

                        <LightTooltip
                          PopperProps={{ style: { marginTop: "-25px" } }}
                          disableHoverListener={!value.cloud_id}
                          title=<span style={{ fontSize: "12px" }}>
                            {value.cloud_id}{" "}
                          </span>
                        >
                          <td
                            data-label="Cloud ID"
                            onClick={() => this.toggleShown(value)}
                            className="text-containt"
                            style={{
                              width: "400px",
                              paddingLeft: "22px",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {value.cloud_id}
                          </td>
                        </LightTooltip>

                        <td
                          onClick={() => this.toggleShown(value)}
                          className="text-containt"
                          style={{ width: "180px", paddingLeft: "22px" }}
                        >
                          {value.last_connected_date ? (
                            <div>
                              {new Date(value.last_connected_date)
                                .toLocaleString("en-US", options)
                                .replaceAll("/", "-")}
                            </div>
                          ) : (
                            <div>---</div>
                          )}
                        </td>
                        <td className="text-containt">
                          <div
                            style={{ textAlign: "right", marginRight: "45px" }}
                          >
                            <img
                              src={EditSvg}
                              alt="EditSvg"
                              onClick={(e) => this.editMonitor(value.id)}
                            ></img>
                          </div>
                        </td>
                      </tr>
                    ))
                  )}

                  {paginationLoading ? (
                    <tr id="trLoading" style={{ paddingBottom: "5%" }}>
                      <td colSpan="14" align="center">
                        <span className="ml-3 spinner spinner-dark"></span>
                      </td>
                    </tr>
                  ) : null}
                  {error && !loading ? (
                    <tr id="trErrorMsg">
                      <td colSpan="12" align="center">
                        <p
                          style={{
                            color: "red",
                            textAlign: "center",
                            verticalAlign: "middle",
                          }}
                        >
                          {error}
                        </p>
                      </td>
                    </tr>
                  ) : null}
                </tbody>
              </table>
            </div>
            {isEdit ? (
              <AddMonitorPage
                id="modal"
                is_edit={isEdit.toString()}
                edit_id={editId}
                facility={this.props.selectedMenu}
                facilities={facilities}
                show={modalShow}
                onHide={(value) => this.modalClose(value)}
              ></AddMonitorPage>
            ) : null}
            {totalCount > RecordsperPage ? (
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  alignContent: "center",
                  justifyContent: "center",
                  marginTop: "20px",
                }}
              >
                {loading
                  ? Array.from({ length: 1 }, (_, index) => (
                      <Pagination
                        style={{
                          display: "flex",
                          flexWrap: "nowrap",
                        }}
                        onChange={this.handlePageChange}
                        count={totalPages}
                        page={currentPage}
                        disabled
                        siblingCount={0}
                        boundaryCount={1}
                        color="teal"
                        key={index + 1}
                        className={`pagination-button ${
                          currentPage === index + 1 ? "active" : ""
                        }`}
                      >
                        {index + 1}
                      </Pagination>
                    ))
                  : Array.from({ length: 1 }, (_, index) => (
                      <Pagination
                        style={{
                          display: "flex",
                          flexWrap: "nowrap",
                        }}
                        onChange={this.handlePageChange}
                        count={totalPages}
                        page={currentPage}
                        siblingCount={0}
                        boundaryCount={1}
                        color="teal"
                        key={index + 1}
                        className={`pagination-button ${
                          currentPage === index + 1 ? "active" : ""
                        }`}
                      >
                        {index + 1}
                      </Pagination>
                    ))}
              </div>
            ) : null}
            {deleteModalShow ? (
              <DeletePage
                show={deleteModalShow}
                headertxt={"Delete Monitor"}
                deleteMsg={deleteMsg}
                toshowokbtn={toshowokbtn}
                haserror={deletePopupError}
                loading={deleteLoader}
                onHide={(opt) => this.deletemodalClose(opt)}
              ></DeletePage>
            ) : null}
          </div>
        </div>
      </>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      monitorDetails: Actions.monitorDetails,
      searchBarChange: Actions.changeSearchBar,
      facilityDetailsChange: Actions.changefacilityDetails,
      refreshMonitorCount: Actions.refreshMonitorCount,
      refreshAssociateApi: Actions.refreshAssociateApi,
      handleDelete: Actions.handleDelete,
      MonitorListRefresh: Actions.MonitorListRefresh,
    },
    dispatch
  );
}

function mapStateToProps(state) {
  return {
    selectedMenu: state.selectedMenu,
    facilityDetails: state.facilityDetails,
    isSearchBar: state.isSearchBar,
    selectedFacility: state.selectedFacility,
    facilityName: state.facilityName,
    searchMonitor: state.searchMonitor,
    isDelete: state.isDelete,
    monitorListRefresh: state.monitorListRefresh,
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Monitors)
);
